import { LocalStorageKeys } from '@authentication/constants';
import LoginResponse from '@authentication/models/login.response.dto';

export const setItem = (key: string, value: any): void => {
  try {
    window.localStorage.setItem(key, removeQuotes(JSON.stringify(value)));
  } catch (e) {
    console.error(e);
  }
};

export const setItemWithQuotes = (key: string, value: any): void => {
  try {
    window.localStorage.setItem(key, JSON.stringify(value));
  } catch (e) {
    console.error(e);
  }
};

export const getItem = (key: string): string | null => {
  return window.localStorage.getItem(key);
};
export const removeQuotes = (str: string) => {
  return str.replace(/['"]+/g, '');
};

export const saveUserCache = (loginResponse: LoginResponse) => {
  window.localStorage.clear();

  setItem(LocalStorageKeys.USER_ID, loginResponse?.user.id);
  setItem(LocalStorageKeys.ACCESS_TOKEN, loginResponse?.token);
  setItem(LocalStorageKeys.REFRESH_TOKEN, loginResponse?.refreshToken);
  setItem(LocalStorageKeys.STORE_ID, loginResponse?.store.id);
};

export const destroyUserCache = () => {
  window.localStorage.clear();
};
